import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as myGlobals from "../../modelos/globales.modelo";

@Component({
    selector: "app-pag-404",
    templateUrl: "./pagina-404.component.html",
    styleUrls: ["./pagina-404.component.css"],
    standalone: false
})
export class Pagina404Component implements OnInit {
  constructor(public oRouter: Router) {
    // let sTokenUrl: string = '';
    // let sHref: string = window.location.href;
    // let sHrefOrigin: string = window.location.origin;
    // let i: number = sHref.indexOf('/code');
    // if (i > 0) {
    //   sTokenUrl = sHref.substring(i + 5, sHref.length).replace('/', '');
    //   // sTokenUrl = sHref.replace(window.location.origin + '/code', '').replace('/', '');
    //   myGlobals.setLocalStore(myGlobals.eLocalStore.tokenurl, sTokenUrl);
    //   this._userService.setToken(sTokenUrl);
    //   console.log('nuevo token localstore 2: ' + sTokenUrl);
    //   // Reescribimos la url sin token, es decir sin /code131573b8790d7da697e7a1210e68d6e2
    //   if (sHrefOrigin.endsWith("/")) {
    //     sHrefOrigin = sHrefOrigin.substring(0, sHref.length - 1);
    //     console.log("Nuevo origin 2: " + sHrefOrigin);
    //   }
    //   window.location.href = sHrefOrigin;
    // }
  }
  ngOnInit() {}
}
